import { render, staticRenderFns } from "./DetailOptions.vue?vue&type=template&id=7dd65af4&scoped=true&"
import script from "./DetailOptions.vue?vue&type=script&lang=js&"
export * from "./DetailOptions.vue?vue&type=script&lang=js&"
import style0 from "./DetailOptions.vue?vue&type=style&index=0&id=7dd65af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd65af4",
  null
  
)

export default component.exports